import { createFileRoute } from '@tanstack/react-router'
import { DocPage } from '@/pages/docs/DocPage'
import { trpc } from '@/lib/trpc'
import { useQuery } from '@tanstack/react-query'
import { CollectionDTO } from '@deepguide-ai/types'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'

// This route handles the default collection (no collection slug in URL)
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/docs/$'
)({
  component: DocPageWrapper,
})

function DocPageWrapper() {
  // Provide collection context to DocPage
  return <DocPage />
}